import { FunctionComponent } from 'react';

import { Text } from '@kanda-libs/ks-design-library';

import useSelectNewRate from './useSelectNewRate';

interface SelectNewRateProps {
  secondLine?: boolean;
}

const SelectNewRate: FunctionComponent<SelectNewRateProps> = function ({
  secondLine = false,
}) {
  const { message } = useSelectNewRate(secondLine);

  return (
    <Text text={message} className="block mb-8 text-purple-500 text-16-24-em" />
  );
};

export default SelectNewRate;
